import { RolePermissionModel } from '@app/domain/UserModel';
import { persistPermission, readPermission } from '@app/services/localStorage.service';
import { getUsers } from '@app/api/user.api';
import { createAction, PrepareAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface PermissionState {
  permission: RolePermissionModel[] | null;
}

const initialState: PermissionState = {
  permission: readPermission(),
};

export const setPermission = createAction<PrepareAction<RolePermissionModel[]>>('permission/setPermission', (newPermission) => {
    persistPermission(newPermission);

  return {
    payload: newPermission,
  };
});

export const doGetPermission = createAsyncThunk('Permissions', async () => {
  try {
    // Perform an asynchronous operation (e.g., API call)
    const response = await getUsers();

    // Return the data to be dispatched
    return response?.data;
  } catch (error) {
    // Handle errors
    throw error;
  }
});

export const permissionSlice = createSlice({
  name: 'Permissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setPermission, (state, action) => {
      state.permission = action.payload;
    });
  },
});

export default permissionSlice.reducer;
